import React from 'react';
import Input from '../../../components/Inputs/Input/Input';
import formStyles from '../../../components/Form/form.module.css';
import { textStyles } from '../../../constants/textStyles';
import { originLabel } from '../../../constants/carOrigin';
import { ENGINE_TYPE_OPTIONS } from '../../Car/NewCar/carInfoInputs';
import { colorName } from '../../Car/NewCar/vinSearch';
import formatDate from '../../../utils/formatDate';
import formatNumber from '../../../utils/formatNumber';

const grid = { display: 'grid', gap: 20, gridTemplateColumns: '1fr 1fr', marginTop: 16 };

const engineLabel = (car) => {
  const code = car?.engineType;
  return ENGINE_TYPE_OPTIONS.find((option) => option.value === code)?.label || car?.complectation?.engine?.title || '';
};

const transmissionLabel = (car) => {
  const value = car?.transmission;
  if (!value) return '';
  return typeof value === 'string' ? value : value.title || value.name || '';
};

// Те же поля, что в форме нового автомобиля, — по выбранной машине и только для просмотра.
export const selectedCarRows = (car) => [
  ['Происхождение автомобиля', originLabel(car?.originCarId, true) || ''],
  ['Марка', car?.mark],
  ['Модель', car?.model],
  ['Год выпуска', car?.issueYear],
  ['VIN', car?.vin],
  ['Цвет кузова', colorName(car?.color)],
  ['Цена', car?.price ? `${formatNumber(car.price)} ₸` : ''],
  ['Номер техпаспорта', car?.texNumber],
  ['Дата выдачи техпаспорта', car?.texDate ? formatDate(car.texDate) : ''],
  ['Объём двигателя', car?.engine_volume],
  ['Тип коробки передач', transmissionLabel(car)],
  ['Пробег, км', car?.mileage],
  ['Тип двигателя', engineLabel(car)],
];

const SelectedCarFields = ({ car }) => (
  <div className={formStyles.borderWrapper}>
    <p style={textStyles.formTitle}>Данные автомобиля</p>
    <div style={grid}>
      {selectedCarRows(car).map(([label, value]) => (
        <Input key={label} label={label} value={value ?? ''} onChange={() => {}} disabled placeholder="—" />
      ))}
    </div>
  </div>
);

export default SelectedCarFields;
